import { render, staticRenderFns } from "./AddPayPlanChangeRequest.vue?vue&type=template&id=66895d36"
import script from "./AddPayPlanChangeRequest.vue?vue&type=script&lang=ts"
export * from "./AddPayPlanChangeRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports